import { Injectable } from '@angular/core'; // Import Injectable to define an injectable service
import { environment } from '@environments/environment'; // Import environment configuration
import { AuthService } from '@app/services/_index';
import { KeplerApiAuthorizerInterceptor } from './kepler-api-authorizer.interceptor';

/**
 * Sets Kepler Credly API requests with an Authorization header necessary to verify the current user's Okta JWT.
 */
@Injectable()
export class KeplerCredlyInterceptor extends KeplerApiAuthorizerInterceptor {
  constructor(authService: AuthService) {
    super(authService, environment.api.kepler.credly.url); // Call the superclass constructor with AuthService and Credly API URL
  }
}
